export default __webpack_public_path__ + "static/media/city palace.94e05aa8.jpg";